import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PriceDisplay from '../../../../components/global/PriceDisplay';
import Badge from '../../../../components/global/Badge';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  clientPrice: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.string,
  }).isRequired,
  pricing: PropTypes.shape({
    price: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.string,
    }),
    discount_price: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.string,
    }),
  }),
  quantity: PropTypes.number,
  freeLabel: PropTypes.node,
};

const CheckoutCartItemPriceDisplay = ({
  className,
  clientPrice,
  pricing,
  quantity,
  loading,
  freeLabel = 'Free',
}) => {
  const classes = classNames({
    'text-extra-bold': true,
    [className]: !!className,
  });

  return (
    <Badge className={classes} badgeStyle="yellow">
      {(() => {
        if (!pricing) {
          return (
            <PriceDisplay
              price={
                quantity ? quantity * clientPrice.value : clientPrice.value
              }
              currency={clientPrice.currency}
              loading={loading}
            />
          );
        }

        return (
          <PriceDisplay
            oldPrice={
              quantity
                ? quantity *
                  (pricing.price.value + (pricing.discount_price?.value ?? 0))
                : pricing.price.value + (pricing.discount_price?.value ?? 0)
            }
            price={
              quantity ? quantity * pricing.price.value : pricing.price.value
            }
            currency={pricing.price.currency}
            showDiscount
            freeLabel={freeLabel}
            loading={loading}
          />
        );
      })()}
    </Badge>
  );
};

CheckoutCartItemPriceDisplay.propTypes = propTypes;

export default CheckoutCartItemPriceDisplay;
